export var EDrawerElements = /* @__PURE__ */ ((EDrawerElements2) => {
  EDrawerElements2["ROOT"] = "root";
  EDrawerElements2["HEADER"] = "header";
  EDrawerElements2["CONTAINERBUTTON"] = "containerButton";
  EDrawerElements2["CONTAINERTITLEDESCRIPTION"] = "containerTitleDescription";
  EDrawerElements2["TITLE"] = "title";
  EDrawerElements2["DESCRIPTION"] = "description";
  EDrawerElements2["CONTENT"] = "content";
  return EDrawerElements2;
})(EDrawerElements || {});
